export const states = [
  { code: 'AK', name: 'Alaska', matchName: 'ak' },
  { code: 'AL', name: 'Alabama', matchName: 'al' },
  { code: 'AR', name: 'Arkansas', matchName: 'ar' },
  { code: 'AZ', name: 'Arizona', matchName: 'az' },
  { code: 'CA', name: 'California', matchName: 'ca' },
  { code: 'CO', name: 'Colorado', matchName: 'co' },
  { code: 'CT', name: 'Connecticut', matchName: 'ct' },
  { code: 'DC', name: 'Washington DC', matchName: 'dc' },
  { code: 'DE', name: 'Delaware', matchName: 'de' },
  { code: 'FL', name: 'Florida', matchName: 'fl' },
  { code: 'GA', name: 'Georgia', matchName: 'ga' },
  { code: 'GU', name: 'Guam', matchName: 'gu' },
  { code: 'HI', name: 'Hawaii', matchName: 'hi' },
  { code: 'IA', name: 'Iowa', matchName: 'ia' },
  { code: 'ID', name: 'Idaho', matchName: 'id' },
  { code: 'IL', name: 'Illinois', matchName: 'il' },
  { code: 'IN', name: 'Indiana', matchName: 'in' },
  { code: 'KS', name: 'Kansas', matchName: 'ks' },
  { code: 'KY', name: 'Kentucky', matchName: 'ky' },
  { code: 'LA', name: 'Louisiana', matchName: 'la' },
  { code: 'MA', name: 'Massachusetts', matchName: 'ma' },
  { code: 'MD', name: 'Maryland', matchName: 'md' },
  { code: 'ME', name: 'Maine', matchName: 'me' },
  { code: 'MI', name: 'Michigan', matchName: 'mi' },
  { code: 'MN', name: 'Minnesota', matchName: 'mn' },
  { code: 'MO', name: 'Missouri', matchName: 'mo' },
  { code: 'MS', name: 'Mississippi', matchName: 'ms' },
  { code: 'MT', name: 'Montana', matchName: 'mt' },
  { code: 'NC', name: 'North Carolina', matchName: 'nc' },
  { code: 'ND', name: 'North Dakota', matchName: 'nd' },
  { code: 'NE', name: 'Nebraska', matchName: 'ne' },
  { code: 'NH', name: 'New Hampshire', matchName: 'nh' },
  { code: 'NJ', name: 'New Jersey', matchName: 'nj' },
  { code: 'NM', name: 'New Mexico', matchName: 'nm' },
  { code: 'NV', name: 'Nevada', matchName: 'nv' },
  { code: 'NY', name: 'New York', matchName: 'ny' },
  { code: 'OH', name: 'Ohio', matchName: 'oh' },
  { code: 'OK', name: 'Oklahoma', matchName: 'ok' },
  { code: 'OR', name: 'Oregon', matchName: 'or' },
  { code: 'PA', name: 'Pennsylvania', matchName: 'pa' },
  { code: 'PR', name: 'Puerto Rico', matchName: 'pr' },
  { code: 'RI', name: 'Rhode Island', matchName: 'ri' },
  { code: 'SC', name: 'South Carolina', matchName: 'sc' },
  { code: 'SD', name: 'South Dakota', matchName: 'sd' },
  { code: 'TN', name: 'Tennessee', matchName: 'tn' },
  { code: 'TX', name: 'Texas', matchName: 'tx' },
  { code: 'UT', name: 'Utah', matchName: 'ut' },
  { code: 'VA', name: 'Virginia', matchName: 'va' },
  { code: 'VI', name: 'Virgin Islands', matchName: 'vi' },
  { code: 'VT', name: 'Vermont', matchName: 'vt' },
  { code: 'WA', name: 'Washington', matchName: 'wa' },
  { code: 'WI', name: 'Wisconsin', matchName: 'wi' },
  { code: 'WV', name: 'West Virginia', matchName: 'wv' },
  { code: 'WY', name: 'Wyoming', matchName: 'wy' }
];

const stateCodeToName = states.reduce((acc, { code, name }) => ({
  ...acc,
  [code]: name
}), {});

const stateNameToCode = states.reduce((acc, { code, name }) => ({
  ...acc,
  [name]: code
}), {});

export function stateCodeForName(name) {
  return stateNameToCode[name];
}

export function stateNameForCode(code) {
  return stateCodeToName[code.toUpperCase()];
}
